"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.rawInstancesToArray = function (instances) {
  var arr = [];
  var keys = Object.keys(instances);

  for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
    var key = keys_1[_i];

    if (instances[key].info) {
      arr.push(instances[key].info);
    }
  }

  return arr;
};